import { useState } from 'react';
const Header = () => {
  const [mode, setMode] = useState(0);

  const toggle = () => {
    if (mode === 0) {
      document.body.classList.add('dark-mode');
      setMode(1);
    }
    if (mode === 1) {
      document.body.classList.remove('dark-mode');
      setMode(0);
    }
  };
  return (
    <div className="Header">
      <div className="header-left">
        <h1>Oğuz Hoto</h1>
        <h2>Geotechnical Engineer | Fullstack Developer | Scuba Instructor</h2>
      </div>
      <div className="header-right">
        <input type="checkbox" id="toggle" />
        <label htmlFor="toggle" onClick={toggle}></label>
      </div>
    </div>
  );
};
export default Header;
